/* eslint-disable react/require-default-props */
import React from 'react';
import { Text } from '../../atoms/Text/Text';
import { Button } from '../../atoms/Button/Button';
import { useBrushaway } from './BrushawayContext';
// Side-effect import — keeps `header__field` / `header__label` rules in the
// bundle whenever this header is mounted, even if a consumer renders raw
// markup instead of the `HeaderField` component.
import '../Header/HeaderField/HeaderFieldStyles.scss';
export function BrushawayHeader({ title, secondaryActions, fields, divider = true, closeLabel = 'Close', fieldsLabel = 'Header fields', className = '' }) {
    const { closeBrushaway } = useBrushaway();
    const headerClasses = ['qmb-ui-brushaway-header', className].filter(Boolean).join(' ');
    return (React.createElement("header", { className: headerClasses },
        React.createElement("div", { className: "qmb-ui-brushaway-header__row qmb-ui-brushaway-header__row--title" },
            React.createElement("div", { className: "qmb-ui-brushaway-header__title", id: "qmb-ui-brushaway-title" }, typeof title === 'string' ? (React.createElement(Text, { variant: "medium", as: "h2" }, title)) : (title)),
            React.createElement("div", { className: "qmb-ui-brushaway-header__actions" },
                secondaryActions,
                React.createElement(Button, { className: "qmb-ui-brushaway-header__close", onClick: closeBrushaway, "aria-label": closeLabel },
                    React.createElement("i", { className: "fa-light fa-xmark", "aria-hidden": "true" })))),
        fields && (React.createElement("div", { className: "qmb-ui-brushaway-header__row qmb-ui-brushaway-header__row--fields", role: "group", "aria-label": fieldsLabel }, fields)),
        divider && React.createElement("hr", { className: "qmb-ui-brushaway-header__divider", "aria-hidden": "true" })));
}
